import React, { useEffect, useState } from "react";
import Select from "react-select";
import { IoCloseOutline } from "react-icons/io5";
import { AiOutlineUserAdd } from "react-icons/ai";
import { FiFilter } from "react-icons/fi";
import { FcRefresh } from "react-icons/fc";
import { BsDownload } from "react-icons/bs";
import { getBeneficiries } from "../../store/actions/BenActions";
import DashLayout from "../../layouts/DashLayout";
import Table from "../../components/Table";
import Overlay from "../../components/Overlay";
import { style, color } from "../../styles/Style";
import Action from "../../components/Action";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { capitalizeFirstLetter } from "../../utils/CapitalizeFirstLetter";
import ReactHtmlTableToExcel from "react-html-table-to-excel";
import changeMonthToText from "../../utils/ChangeMonthToText";

import {
  deleteParents,
  updateParents,
  addParents,
  getParents,
} from "../../store/actions/ParentsActions";
import {
  deleteCaregivers,
  updateCaregivers,
  addCaregiver,
  getCaregivers,
} from "../../store/actions/CaregiversActions";
import { useDispatch } from "react-redux";
import { changeFromTimeStamp } from "../../utils/changeFromTimeStamp";
import ContentLoader from "react-content-loader";

function Caregiver() {
  // declate dispatch
  const dispatch = useDispatch();
  // load parents
  const beneficiaryParents = useSelector((state) => state.beneficiaryParents);
  const caregivers = useSelector((state) => state.beneficiaryCaregivers);
  const beneficiaries = useSelector((state) => state.beneficiries);
  const loaders = useSelector((state) => state.loadersState);

  // declare parents
  const [benParents, setBenParents] = useState({
    id: "",
    beneficiaryId: "",
    fatherName: "",
    motherName: "",
    status: "",
  });

  const [benCaregiver, setBenCaregiver] = useState({
    beneficiaryId: "",
    caregiverName: "",
    endDate: "",
    relationName: "",
    startDate: "",
  });

  const [openUpperTab, setOpenUpperTab] = useState(1);
  // overlays
  const [addBenOverlay, setAddBeneOverlay] = useState(0);
  function benOverlayController() {
    setAddBeneOverlay(!addBenOverlay);
  }

  const [filterBenOverlay, setFilterBeneOverlay] = useState(0);
  function filterOverlayController() {
    setFilterBeneOverlay(!filterBenOverlay);
  }
  const [editBenOverlay, setEditBeneOverlay] = useState(0);
  function editOverlayController(passedBenParents) {
    setEditBeneOverlay(!editBenOverlay);
    setBenParents({
      id: passedBenParents.id,
      beneficiaryId: passedBenParents.beneficiaryId,
      fatherName: passedBenParents.father,
      motherName: passedBenParents.mother,
      status: passedBenParents.status,
    });
  }

  const [editcaregivers, setEditcaregivers] = useState(0);
  function editcaregiversController(passedCaregiver) {
    setEditcaregivers(!editcaregivers);
    setBenCaregiver({
      id: passedCaregiver.id,
      beneficiaryId: passedCaregiver.beneficiaryId,
      caregiverName: passedCaregiver.caregiverName,
      endDate: changeFromTimeStamp(passedCaregiver.endDate),
      relationName: passedCaregiver.relationName,
      startDate: changeFromTimeStamp(passedCaregiver.startDate),
    });
  }
  const [addcaregivers, setAddcaregivers] = useState(0);
  function addCaregiversController() {
    setAddcaregivers(!addcaregivers);
  }
  const [filtercaregiversOverlay, setFiltercaregiversOverlay] = useState(0);
  function caregiversFilterOverlayController() {
    setFiltercaregiversOverlay(!filtercaregiversOverlay);
  }

  // for Caregiver table
  const columns = React.useMemo(
    () => [
      {
        Header: "#",
        accessor: "count",
      },
      {
        Header: "Beneficiary",
        accessor: "beneficiary",
      },

      {
        Header: "Mother",
        accessor: "mother",
      },
      {
        Header: "Father",
        accessor: "father",
      },
      {
        Header: "Status",
        accessor: "status",
      },
      {
        Header: "Action",
        accessor: "action",
      },
    ],
    []
  );

  const caregiversColumns = React.useMemo(
    () => [
      {
        Header: "#",
        accessor: "count",
      },
      {
        Header: "Beneficiary",
        accessor: "beneficiary",
      },
      {
        Header: "FromDate",
        accessor: "startDate",
      },
      {
        Header: "ToDate",
        accessor: "endDate",
      },
      {
        Header: "Cargiver",
        accessor: "caregiver",
      },
      {
        Header: "Action",
        accessor: "action",
      },
    ],
    []
  );

  // transform parents data
  let [loadedParents, setLoadedParents] = useState([]);
  useEffect(() => {
    setLoadedParents([]);
    for (let i = 0; i < beneficiaryParents.length; i++) {
      const benParent = {
        count: i + 1,
        id: beneficiaryParents[i].id,
        beneficiaryId: beneficiaryParents[i].beneficiary.id,
        beneficiary: ` ${beneficiaryParents[i].beneficiary.firstName}  
      ${beneficiaryParents[i].beneficiary.lastName}`,
        mother: beneficiaryParents[i].motherName,
        father: beneficiaryParents[i].fatherName,
        status: (
          <div className="py-1 px-2 rounded  font-normal fit-content">
            {capitalizeFirstLetter(beneficiaryParents[i].status)}
          </div>
        ),
        action: (
          <Action
            editAction={() => editOverlayController(benParent)}
            deleteAction={() => {
              handleParentsDelete(beneficiaryParents[i].id);
            }}
          />
        ),
      };

      setLoadedParents((loadedParents) => [...loadedParents, benParent]);

      if (
        loaders.benCaregiver.deletingAction &&
        loaders.benCaregiver.deletingAction.deleting
      ) {
        const currentBenefs = loadedParents;
        const newData = currentBenefs.map((parent) =>
          parent.id === loaders.benCaregiver.deletingAction.id
            ? {
              ...parent,
              action: (
                <div className="spinner red-spinner m-auto">
                  <div className="bounce1"></div>
                  <div className="bounce2"></div>
                  <div className="bounce3"></div>
                </div>
              ),
            }
            : parent
        );
        setLoadedParents(newData);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [beneficiaryParents, loaders.benParent.deletingAction]);

  let [loadingParents, setLoadingParents] = useState([]);
  useEffect(() => {
    setLoadingParents([]);
    for (let i = 0; i < 5; i++) {
      const benParent = {
        count: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        beneficiary: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        mother: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        father: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        status: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        action: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
      };

      setLoadingParents((loadingParents) => [...loadingParents, benParent]);
    }
  }, [loaders.benParent.fetchingLoaders]);

  // transform caregivers data
  let [loadedCaregivers, setLoadedCaregivers] = useState([]);
  useEffect(() => {
    setLoadedCaregivers([]);
    for (let i = 0; i < caregivers.length; i++) {
      const benCargiver = {
        count: i + 1,
        id: caregivers[i].id,
        beneficiary: ` ${caregivers[i].beneficiary.firstName}  
      ${caregivers[i].beneficiary.lastName}`,
        startDate: changeMonthToText(caregivers[i].startDate),
        endDate: changeMonthToText(caregivers[i].endDate),
        caregiver: ` ${caregivers[i].caregiverName}(${caregivers[i].relationName})`,
        action: (
          <Action
            editAction={() => editcaregiversController(caregivers[i])}
            deleteAction={() => {
              handleCaregiverDelete(caregivers[i].id);
            }}
          />
        ),
      };
      setLoadedCaregivers((loadedCaregivers) => [
        ...loadedCaregivers,
        benCargiver,
      ]);

      if (
        loaders.benCaregiver.deletingAction &&
        loaders.benCaregiver.deletingAction.deleting
      ) {
        const currentAssoccParents = loadedCaregivers;
        const newData = currentAssoccParents.map((caregiver) =>
          caregiver.id === loaders.benCaregiver.deletingAction.id
            ? {
              ...caregiver,
              action: (
                <div className="spinner red-spinner m-auto">
                  <div className="bounce1"></div>
                  <div className="bounce2"></div>
                  <div className="bounce3"></div>
                </div>
              ),
            }
            : caregiver
        );
        setLoadedCaregivers(newData);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [caregivers, loaders.benCaregiver.deletingAction]);

  let [loadingBenCaregivers, setLoadingBenCaregivers] = useState([]);

  useEffect(() => {
    setLoadingBenCaregivers([]);
    for (let i = 0; i < 5; i++) {
      const benCargiver = {
        count: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        beneficiary: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        startDate: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        endDate: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        caregiver: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
        action: (
          <ContentLoader
            speed={2}
            height={15}
            viewBox="0 0 60 15"
            backgroundColor="#f3f4f6"
            foregroundColor="#ecebeb"
          >
            <rect x="2" y="2" rx="3" ry="3" width="50" height="7" />
          </ContentLoader>
        ),
      };
      setLoadingBenCaregivers((loadingBenCaregivers) => [
        ...loadingBenCaregivers,
        benCargiver,
      ]);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }
  }, [loaders.benCaregiver.fetchingLoaders]);

  // handle submit functions
  const handleParentsSubmit = (e) => {
    e.preventDefault();
    if (benParents.id) {
      const id = benParents.id;
      const updatedParentsInfo = {
        id: benParents.id,
        beneficiaryId: benParents.beneficiaryId,
        fatherName: benParents.fatherName,
        motherName: benParents.motherName,
        status: benParents.status,
      };

      dispatch(updateParents(updatedParentsInfo, id, closeParentAfterUpdating));
    } else {
      dispatch(addParents(benParents, closeParentFormAfterAdding));
    }
  };
  const handleCaregiverSubmit = (e) => {
    e.preventDefault();
    if (benCaregiver.id) {
      const id = benCaregiver.id;
      const updatedCaregiverInfo = {
        id: benCaregiver.id,
        beneficiaryId: benCaregiver.beneficiaryId,
        caregiverName: benCaregiver.caregiverName,
        endDate: benCaregiver.endDate,
        relationName: benCaregiver.relationName,
        startDate: benCaregiver.startDate,
      };
      dispatch(
        updateCaregivers(updatedCaregiverInfo, id, closeCaregiverAfterUpdating)
      );
    } else {
      dispatch(addCaregiver(benCaregiver, closeCaregiverFormAfterAdding));
    }
  };
  // handle delete actions

  // handle delete ac year
  const handleParentsDelete = (id) => {
    dispatch(deleteParents(id));
  };
  // handle delete ac year
  const handleCaregiverDelete = (id) => {
    dispatch(deleteCaregivers(id));
  };
  // reloads
  useEffect(() => {
    dispatch(getBeneficiries());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(getCaregivers());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // reload parents from databas
  useEffect(() => {
    dispatch(getParents());
    console.log(beneficiaryParents);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // beneficiries select option
  const beneficiriesOption = [];
  for (let i = 0; i < beneficiaries.length; i++) {
    const beneficiary = {
      value: beneficiaries[i].id,
      label: beneficiaries[i].beneficiaryCode,
      name: beneficiaries[i].firstName + " " + beneficiaries[i].lastName,
    };

    beneficiriesOption.push(beneficiary);
  }

  const selectedBeneficiary = beneficiriesOption.find(
    (beneficiary) => beneficiary.value === benParents.beneficiaryId
  );

  const careSelectedBeneficiary = beneficiriesOption.find(
    (beneficiary) => beneficiary.value === benCaregiver.beneficiaryId
  );

  const beneficiaryStatus = [
    {
      value: "All alive",
      label: "All alive",
    },
    {
      value: "Lost mother",
      label: "Lost mother",
    },
    {
      value: "Lost father",
      label: "Lost father",
    },
    {
      value: "Lost both parents",
      label: "Lost both parents",
    },
  ];



  // closing parent after cu
  function closeParentFormAfterAdding() {
    benOverlayController();
    setBenParents({
      id: "",
      beneficiaryId: "",
      fatherName: "",
      motherName: "",
      status: "",
    });
  }

  function closeParentAfterUpdating() {
    editOverlayController({
      id: "",
      beneficiaryId: "",
      fatherName: "",
      motherName: "",
      status: "",
    });
  }
  // closing parent after cu
  function closeCaregiverFormAfterAdding() {
    addCaregiversController();
    setBenCaregiver({
      id: "",
      beneficiaryId: "",
      caregiverName: "",
      endDate: "",
      relationName: "",
      startDate: "",
    });
  }

  function closeCaregiverAfterUpdating() {
    editcaregiversController({
      id: "",
      beneficiaryId: "",
      caregiverName: "",
      endDate: "",
      relationName: "",
      startDate: "",
    });
  }
  return (
    <DashLayout>
      <div className="bg-white mx-10">
        <div className="text-xs">
          <ToastContainer />
        </div>
        <div className="flex flex-col md:flex-row p-10 pl-10 pb-0">
          <h2 className="font-semibold">Beneficiary caregivers</h2>
          <div className="md:m-auto md:mr-0">
            <button
              className="p-2 mr-2 rounded text-white bg-indigo-500 hover:bg-indigo-400 title-tip"
              onClick={() => {
                openUpperTab === 1
                  ? benOverlayController()
                  : addCaregiversController();
              }}
              message="Register"
            >
              <AiOutlineUserAdd />
            </button>
            <button
              className="p-2 mr-2 rounded text-gray-500 border border-gray-300 hover:bg-gray-100 title-tip"
              onClick={() => {
                openUpperTab === 1
                  ? filterOverlayController()
                  : caregiversFilterOverlayController();
              }}
              message="Filter"
            >
              <FiFilter />
            </button>
            <button
              className="p-2 mr-2 rounded text-gray-500 border border-gray-300 hover:bg-gray-100 title-tip"
              message="Refresh"
              onClick={() => {
                openUpperTab === 1
                  ? dispatch(getParents())
                  : dispatch(getCaregivers());
              }}
            >
              <FcRefresh
                className={
                  (openUpperTab === 1 && loaders.benParent.fetchingLoaders) ||
                    (openUpperTab === 2 && loaders.benCaregiver.fetchingLoaders)
                    ? " refresh-loader"
                    : " "
                }
              />
            </button>

            {/* {openUpperTab === 1 ? (
              <PDFDownloadLink
                document={<DownloadParents />}
                fileName="parents.pdf"
              >
                <button
                  className="p-2 mr-2 rounded text-gray-500 border border-gray-300 hover:bg-gray-100 title-tip"
                  message="Download"
                >
                  <BsDownload />
                </button>
              </PDFDownloadLink>
            ) : (
              <PDFDownloadLink
                document={<DownloadCaregivers />}
                fileName="caregivers.pdf"
              >
                <button
                  className="p-2 mr-2 rounded text-gray-500 border border-gray-300 hover:bg-gray-100 title-tip"
                  message="Download"
                >
                  <BsDownload />
                </button>
              </PDFDownloadLink>
            )} */}

            {
              openUpperTab === 1 ? (<ReactHtmlTableToExcel
                id="test-table-xls-button"
                table="parents-table-to-xls"
                filename={`parents-`}
                sheet="tablexls"
                buttonText={<button
                  className="p-2 mr-2 rounded text-gray-500 border border-gray-40 hover:bg-gray-100 title-tip"
                  message="Download"
                > <BsDownload /></button>} />) : (
                <ReactHtmlTableToExcel
                  id="test-table-xls-button"
                  table="caregivers-table-to-xls"
                  filename={`caregivers-`}
                  sheet="tablexls"
                  buttonText={<button
                    className="p-2 mr-2 rounded text-gray-500 border border-gray-40 hover:bg-gray-100 title-tip"
                    message="Download"
                  > <BsDownload /></button>} />
              )
            }

          </div>
        </div>
        {/* Caregiver tabs */}
        <div className="mt-4 flex flex-wrap">
          <div className="w-full">
            <ul
              className="flex mb-0 list-none flex-wrap  font-normal  flex-row w-full"
              role="tablist"
            >
              <li className="-mb-px  last:mr-0 ml-10">
                <a
                  className={
                    "text-xs   px-5 py-1 pl-0   block leading-normal" +
                    (openUpperTab === 1
                      ? " text-white bg-indigo-500 rounded rounded-r-none border-b-2 border-" +
                      color +
                      "-500"
                      : " text-indigo-50 bg-indigo-300 border-b-2 rounded rounded-r-none border-indigo-300")
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    setOpenUpperTab(1);
                  }}
                  data-toggle="tab"
                  href="#link1"
                  role="tablist"
                >
                  <i className="fas fa-space-shuttle text-base mr-1"></i>{" "}
                  Parents
                </a>
              </li>
              <li className="-mb-px  last:mr-0">
                <a
                  className={
                    "text-xs   px-5 py-1 pl-0  block leading-normal " +
                    (openUpperTab === 2
                      ? " text-white bg-indigo-500 rounded rounded-l-none border-b-2 border-" +
                      color +
                      "-500"
                      : " text-indigo-50 bg-indigo-300 border-b-2 rounded rounded-l-none border-indigo-300")
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    setOpenUpperTab(2);
                  }}
                  data-toggle="tab"
                  href="#link2"
                  role="tablist"
                >
                  <i className="fas fa-cog text-base mr-1"></i>Other Caregivers
                </a>
              </li>
            </ul>
            <div className="relative flex flex-col min-w-0 break-words  w-full mb-2">
              <div>
                <div className="tab-content tab-space">
                  <div
                    className={openUpperTab === 1 ? "flex flex-col" : "hidden"}
                    id="link1"
                  >
                    <div className="pb-5 px-0 pr-10  flex flex-wrap  w-full">
                      {/* Caregiver table */}
                      <div className="w-full">
                        {(!loaders.benParent.fetchingLoaders &&
                          beneficiaryParents.length < 1) |
                          loaders.benParent.fetchFailedMessage ? (
                          <div
                            className={
                              !loaders.benParent.fetchFailedMessage
                                ? "bg-gray-100 fit-content  text-xs rounded text-center py-2 px-4 text-gray-500 font-semibold m-auto"
                                : "bg-red-100 text-xs rounded fit-content text-center py-2 px-4 text-red-500 font-semibold m-auto"
                            }
                          >
                            <p className="m-auto">
                              {!loaders.benParent.fetchFailedMessage
                                ? "No parent info record found"
                                : loaders.benParent.fetchFailedMessage}
                            </p>
                          </div>
                        ) : (
                          <Table
                            data={
                              loaders.benParent.fetchingLoaders
                                ? loadingParents
                                : loadedParents
                            }
                            columns={columns}
                          />
                        )}{" "}
                      </div>
                    </div>
                  </div>
                  {/* caregiverss table */}
                  <div
                    className={openUpperTab === 2 ? "flex flex-col" : "hidden"}
                    id="link1"
                  >
                    <div className="pb-5 px-0  flex flex-wrap  w-full">
                      {/* Academics table */}
                      <div className="w-full">
                        {(!loaders.benCaregiver.fetchingLoaders &&
                          caregivers.length < 1) |
                          loaders.benCaregiver.fetchFailedMessage ? (
                          <div
                            className={
                              !loaders.benCaregiver.fetchFailedMessage
                                ? "bg-gray-100 fit-content  text-xs rounded text-center py-2 px-4 text-gray-500 font-semibold m-auto"
                                : "bg-red-100 text-xs rounded fit-content text-center py-2 px-4 text-red-500 font-semibold m-auto"
                            }
                          >
                            <p className="m-auto">
                              {!loaders.benCaregiver.fetchFailedMessage
                                ? "No caregiver record found"
                                : loaders.benCaregiver.fetchFailedMessage}
                            </p>
                          </div>
                        ) : (
                          <Table
                            data={
                              loaders.benCaregiver.fetchingLoaders
                                ? loadingBenCaregivers
                                : loadedCaregivers
                            }
                            columns={caregiversColumns}
                          />
                        )}{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* end.... */}
        {/*add Caregiver overlay  */}
        <div
          className={
            addBenOverlay || editBenOverlay ? "flex w-screen" : "hidden"
          }
        >
          <Overlay>
            <div className="bg-white m-auto  rounded">
              <div
                className={
                  loaders.benParent.message
                    ? "bg-red-100 text-xs rounded text-center py-2 text-red-500 font-semibold"
                    : "hidden"
                }
              >
                <p>{loaders.benParent.message}</p>
              </div>
              <div className="p-10">
                <div className="flex">
                  <h2 className="font-semibold  w-80">
                    {addBenOverlay
                      ? "Register beneficiary parents"
                      : "Change beneficiary parents info"}
                  </h2>
                  <div className="m-auto mr-0">
                    <button
                      className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                      onClick={() => {
                        addBenOverlay
                          ? benOverlayController()
                          : editOverlayController({
                            id: "",
                          });
                      }}
                    >
                      <IoCloseOutline className="text-white" />{" "}
                    </button>
                  </div>
                </div>{" "}
                <div className="flex flex-wrap">
                  <div className="w-full">
                    <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-2">
                      <div>
                        <div className="tab-content tab-space">
                          <form
                            className="flex flex-col pt-3"
                            onSubmit={handleParentsSubmit}
                          >
                            {/*  field */}
                            <div className="py-2 w-full">
                              <label>Beneficiary Id</label>
                              <Select
                                options={beneficiriesOption}
                                value={beneficiriesOption.find(
                                  (obj) =>
                                    obj.value === benParents.beneficiaryId
                                )}
                                onChange={(e) =>
                                  setBenParents({
                                    ...benParents,
                                    beneficiaryId: e.value,
                                  })
                                }
                              />
                            </div>
                            {/*  field */}
                            <div className="py-2 w-full">
                              <label>Name</label>
                              <div className={style.field.parentDiv}>
                                <input
                                  type="text"
                                  className={style.field.input + "uppercase"}
                                  value={
                                    benParents.beneficiaryId
                                      ? selectedBeneficiary.name
                                      : ""
                                  }
                                  readOnly
                                />
                              </div>
                            </div>
                            {/*  field */}
                            <div className="py-2  w-full">
                              <label>Father </label>
                              <div className="w-full">
                                <div className={style.field.parentDiv}>
                                  <input
                                    type="text"
                                    className={style.field.input}
                                    value={benParents.fatherName}
                                    onChange={(e) =>
                                      setBenParents({
                                        ...benParents,
                                        fatherName: e.target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                            {/*  field */}
                            <div className="py-2  w-full">
                              <label>Mother </label>
                              <div className="w-full">
                                <div className={style.field.parentDiv}>
                                  <input
                                    type="text"
                                    className={style.field.input}
                                    value={benParents.motherName}
                                    onChange={(e) =>
                                      setBenParents({
                                        ...benParents,
                                        motherName: e.target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                            {/*  field */}
                            <div className="py-2  w-full">
                              <label>Parents status </label>
                              <Select
                                options={beneficiaryStatus}
                                value={beneficiaryStatus.find(
                                  (obj) => obj.value === benParents.status
                                )}
                                onChange={(e) =>
                                  setBenParents({
                                    ...benParents,
                                    status: e.value,
                                  })
                                }
                              />
                            </div>

                            {/* save btn */}
                            <button
                              type="submit"
                              className={style.loginBtn}
                              disabled={loaders.benParent.sendingLoader}
                            >
                              {!loaders.benParent.sendingLoader ? (
                                <p className="m-auto">
                                  {addBenOverlay ? "Save" : "Update"}
                                </p>
                              ) : (
                                <div className="spinner m-auto">
                                  <div className="bounce1"></div>
                                  <div className="bounce2"></div>
                                  <div className="bounce3"></div>
                                </div>
                              )}
                            </button>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Overlay>
        </div>
        {/*add caregivers overlay  */}
        <div
          className={
            addcaregivers || editcaregivers ? "flex w-screen" : "hidden"
          }
        >
          <Overlay>
            <div className="bg-white m-auto  rounded">
              <div
                className={
                  loaders.benCaregiver.message
                    ? "bg-red-100 text-xs rounded text-center py-2 text-red-500 font-semibold"
                    : "hidden"
                }
              >
                <p>{loaders.benCaregiver.message}</p>
              </div>
              <div className="p-10">
                <div className="flex">
                  <h2 className="font-semibold  w-80">
                    {addcaregivers
                      ? "Register beneficiary caregivers"
                      : "Change beneficiary caregivers info"}
                  </h2>
                  <div className="m-auto mr-0">
                    <button
                      className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                      onClick={() => {
                        addcaregivers
                          ? addCaregiversController()
                          : editcaregiversController({
                            id: "",
                          });
                      }}
                    >
                      <IoCloseOutline className="text-white" />{" "}
                    </button>
                  </div>
                </div>{" "}
                <form
                  className="flex flex-wrap"
                  onSubmit={handleCaregiverSubmit}
                >
                  <div className="w-full">
                    <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-2">
                      <div>
                        <div className="flex flex-col pt-3">
                          {/*  field */}
                          <div className="py-2 w-full">
                            <label>Beneficiary Id</label>
                            <Select
                              options={beneficiriesOption}
                              value={beneficiriesOption.find(
                                (obj) =>
                                  obj.value === benCaregiver.beneficiaryId
                              )}
                              onChange={(e) =>
                                setBenCaregiver({
                                  ...benCaregiver,
                                  beneficiaryId: e.value,
                                })
                              }
                            />
                          </div>
                          {/*  field */}
                          <div className="py-2 w-full">
                            <label>Name </label>
                            <div className={style.field.parentDiv}>
                              <input
                                type="text"
                                className={style.field.input}
                                value={
                                  benCaregiver.beneficiaryId
                                    ? careSelectedBeneficiary.name
                                    : ""
                                }
                                readOnly
                              />
                            </div>
                          </div>
                          {/*  field */}
                          <div className="py-2  w-full">
                            <div className="flex w-full">
                              <div className="w-1/2">
                                <label>StartDate </label>

                                <div className={style.field.parentDiv}>
                                  <input
                                    type="date"
                                    className={style.field.input}
                                    value={benCaregiver.startDate}
                                    onChange={(e) =>
                                      setBenCaregiver({
                                        ...benCaregiver,
                                        startDate: e.target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>
                              <div className="ml-2 w-1/2">
                                <label>EndDate </label>
                                <div className={style.field.parentDiv}>
                                  <input
                                    type="date"
                                    className={style.field.input}
                                    value={benCaregiver.endDate}
                                    onChange={(e) =>
                                      setBenCaregiver({
                                        ...benCaregiver,
                                        endDate: e.target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          {/*  field */}
                          <div className="py-2 w-full">
                            <div className="flex w-full">
                              <div className="w-1/2">
                                <label>Caregiver </label>

                                <div className={style.field.parentDiv}>
                                  <input
                                    type="text"
                                    className={style.field.input}
                                    value={benCaregiver.motherName}
                                    onChange={(e) =>
                                      setBenCaregiver({
                                        ...benCaregiver,
                                        caregiverName: e.target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>
                              <div className="ml-2">
                                <label>Relationship</label>

                                <div
                                  className={style.field.parentDiv + " w-1/2"}
                                >
                                  <input
                                    type="text"
                                    className={style.field.input}
                                    value={benCaregiver.relationName}
                                    onChange={(e) =>
                                      setBenCaregiver({
                                        ...benCaregiver,
                                        relationName: e.target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* save btn */}
                          <button
                            type="submit"
                            className={style.loginBtn}
                            disabled={loaders.benCaregiver.sendingLoader}
                          >
                            {!loaders.benCaregiver.sendingLoader ? (
                              <p className="m-auto">
                                {addcaregivers ? "Save" : "Update"}
                              </p>
                            ) : (
                              <div className="spinner m-auto">
                                <div className="bounce1"></div>
                                <div className="bounce2"></div>
                                <div className="bounce3"></div>
                              </div>
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Overlay>
        </div>
        {/* filter Caregiver  overlay */}
        <div className={filterBenOverlay ? "flex w-screen" : "hidden"}>
          <Overlay>
            <div className="p-10 bg-white m-auto  rounded">
              <div className="flex">
                <h2 className="font-semibold w-80">{"Filter parents info"}</h2>
                <div className="m-auto mr-0">
                  <button
                    className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                    onClick={() => {
                      filterOverlayController();
                    }}
                  >
                    <IoCloseOutline className="text-white" />{" "}
                  </button>
                </div>
              </div>{" "}
              <div className="flex flex-col pt-3">
                {/*  field */}
                <div className="py-2 w-full">
                  <label>Beneficiary range</label>
                  <div className="flex w-full">
                    <Select options={beneficiaries} className="w-1/2 mr-2" />

                    <Select options={beneficiaries} className="w-1/2" />
                  </div>{" "}
                </div>
                {/*  field */}
                <div className="py-2  w-full">
                  <label>Parents status</label>
                  <Select options={beneficiaryStatus} isMulti />
                </div>
                {/* save btn */}
                <button type="submit" className={style.loginBtn}>
                  <p className="m-auto">{"Apply"}</p>
                </button>
              </div>
            </div>
          </Overlay>
        </div>
        {/* filter caregiverss  overlay */}
        <div className={filtercaregiversOverlay ? "flex w-screen" : "hidden"}>
          <Overlay>
            <div className="p-10 bg-white m-auto  rounded">
              <div className="flex">
                <h2 className="font-semibold">{"Filter caregivers info"}</h2>
                <div className="m-auto mr-0">
                  <button
                    className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                    onClick={() => {
                      caregiversFilterOverlayController();
                    }}
                  >
                    <IoCloseOutline className="text-white" />{" "}
                  </button>
                </div>
              </div>{" "}
              <div className="flex flex-col pt-3">
                {/*  field */}
                <div className="py-2 w-full">
                  <label>Beneficiary range</label>
                  <div className="flex w-full">
                    <Select options={beneficiaries} className="w-1/2 mr-2" />

                    <Select options={beneficiaries} className="w-1/2" />
                  </div>{" "}
                </div>

                {/*  field */}
                <div className="py-2 w-full">
                  <label>StartDate range</label>
                  <div className="flex w-full">
                    <div className={style.field.parentDiv + " mr-2 w-1/2"}>
                      <input
                        type="date"
                        className={style.field.input}
                        placeholder="Guhera"
                      />
                    </div>
                    <div className={style.field.parentDiv + " w-1/2"}>
                      <input
                        type="date"
                        className={style.field.input}
                        placeholder="Kugeza"
                      />
                    </div>
                  </div>
                </div>
                {/*  field */}
                <div className="py-2 w-full">
                  <label>EndDate range</label>
                  <div className="flex w-full">
                    <div className={style.field.parentDiv + " mr-2 w-1/2"}>
                      <input
                        type="date"
                        className={style.field.input}
                        placeholder="Guhera"
                      />
                    </div>
                    <div className={style.field.parentDiv + " w-1/2"}>
                      <input type="date" className={style.field.input} />
                    </div>
                  </div>
                </div>
                {/* save btn */}
                <button type="submit" className={style.loginBtn}>
                  <p className="m-auto">{"Apply"}</p>
                </button>
              </div>
            </div>
          </Overlay>
        </div>
      </div>

      <table className="table text-left table-to-export" id="parents-table-to-xls">
        <thead className="thead-dark">
          <tr>
            <th>Beneficiary</th>
            <th>Father's name</th>
            <th>Mother's name</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>

          {beneficiaryParents.map((benParents) =>
            <tr>
              <td>{benParents.beneficiary.firstName}
                {benParents.beneficiary.lastName}</td>
              <td>{benParents.fatherName}</td>
              <td>{benParents.motherName}</td>
              <td>{benParents.status}</td>
            </tr>
          )}
        </tbody>
      </table>

      {/* <table className="table text-left table-to-export" id="caregivers-table-to-xls">
        <thead className="thead-dark">
          <tr>
            <th>Beneficiary</th>
            <th>Father's name</th>
            <th>Mother's name</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>

          {beneficiaryParents.map((benParents) =>
            <tr>
              <td>{benParents.beneficiary.firstName}
                {benParents.beneficiary.lastName}</td>
              <td>{benParents.fatherName}</td>
              <td>{benParents.motherName}</td>
              <td>{benParents.status}</td>
            </tr>
          )}
        </tbody>
      </table> */}
    </DashLayout>
  );
}

export default Caregiver;
